"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultStyle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
var LoFRegexTypes;
(function (LoFRegexTypes) {
    LoFRegexTypes["cross"] = "cross";
    LoFRegexTypes["content"] = "content";
    LoFRegexTypes["spaceId"] = "spaceId";
    LoFRegexTypes["reentry"] = "reentry";
    LoFRegexTypes["error"] = "error";
})(LoFRegexTypes || (LoFRegexTypes = {}));
const LoFRegex = {
    [LoFRegexTypes.cross]: /^(\(|\))+/,
    [LoFRegexTypes.content]: /^[ a-zA-Z0-9,.\-_#+*'`´?!= \/&%§öÖäÄ€%&"^–<>\\]+/,
    [LoFRegexTypes.spaceId]: /^\$\d+/,
    [LoFRegexTypes.reentry]: /^(\[\d+\])/,
    [LoFRegexTypes.error]: /.*/,
};
exports.defaultStyle = {
    cross: {
        color: "inherit",
    },
    content: {
        color: "#A06E3C",
    },
    spaceId: {
        color: "#4B8B8B",
    },
    reentry: {
        color: "#CA4A49",
    },
    error: {
        color: "#CA4A49",
    },
};
/**
 * @param {children} expression - Bracket Expression LoF String e.g ((b)(a)c)
 * @param {LoFHighlightStyleSheet} highlighting - Custom style sheet for syntax highlighted
 *
 * Syntax Highlighting of the given expression.
 */
function SyntaxHighlighting({ children, highlighting = exports.defaultStyle, }) {
    const output = [];
    const maxIterations = children.length;
    const process = (type, i) => {
        const match = LoFRegex[type].exec(children);
        if (match !== null) {
            output.push((0, jsx_runtime_1.jsx)("span", Object.assign({ style: highlighting[type] }, { children: match[0] }), `${match[0]}_${i}`));
            children = children.slice(match[0].length);
            return true;
        }
        return false;
    };
    const processError = (i) => {
        output.push((0, jsx_runtime_1.jsx)("span", Object.assign({ style: highlighting[LoFRegexTypes.error] }, { children: children[0] }), `${children[0]}_${i}`));
        children = children.slice(1);
    };
    for (let i = 0; i < maxIterations && children.length > 0; ++i) {
        if (process(LoFRegexTypes.cross, i))
            continue;
        if (process(LoFRegexTypes.content, i))
            continue;
        if (process(LoFRegexTypes.spaceId, i))
            continue;
        if (process(LoFRegexTypes.reentry, i))
            continue;
        processError(i);
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: output });
}
exports.default = SyntaxHighlighting;
